import React from 'react'
import PropTypes from 'prop-types'
import StripeSidebar from '../components/StripeSidebar'
import * as pagesMap from '../index'
import './index.scss'

const PageOutputSidebar = ({ sidebarConfig, contentConfig }) => {
  const { page, pageConfig } = contentConfig
  const Page = pagesMap[page] || pagesMap.PageCustom

  return (
    <div className='main-wrapper ublique-page-sidebar'>
      <div className='sections'>
        <StripeSidebar config={sidebarConfig} />
        <Page {...pageConfig} />
      </div>
    </div>
  )
}

PageOutputSidebar.propTypes = {
  sidebarConfig: PropTypes.object.isRequired,
  contentConfig: PropTypes.object.isRequired
}

export default PageOutputSidebar
